import { Reveal } from "@/components/Reveal";

export const SectionHeader = ({ eyebrow, title, lead, align = "left", light = false, className = "", testId, size = "md" }) => (
  <Reveal className={`${align === "center" ? "mx-auto text-center" : ""} max-w-2xl ${className}`} data-testid={testId}>
    {eyebrow && <span className={`eyebrow ${light ? "eyebrow-light" : ""} ${align === "center" ? "justify-center" : ""}`}>{eyebrow}</span>}
    <h2 className={`${size === "lg" ? "section-title-lg" : "section-title"} mt-4 ${light ? "text-white" : ""}`}>{title}</h2>
    {lead && <p className={`lead mt-5 ${light ? "text-white/70" : ""}`}>{lead}</p>}
  </Reveal>
);
